import { render, staticRenderFns } from "./general2.html?vue&type=template&id=d2a89e5c&external"
import script from "./general2.vue?vue&type=script&lang=js"
export * from "./general2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports